import React, { useEffect, useRef, useState } from 'react'
import styles from '../styles/vipRules.module.scss'
import { useTranslation } from 'react-i18next'


const VipRules = () => {
  const { t } = useTranslation('vip')
  const list = [
    {
      title: t('vipRules.criteria1'),
      content: t('vipRules.promotionCriteria')
    },
    {
      title: t('vipRules.criteria2'),
      content: t('vipRules.vipUpgradeRule')
    },
    {
      title: t('vipRules.criteria3'),
      content: t('vipRules.vipRetentionRule')
    },
    {
      title: t('vipRules.criteria4'),
      content: t('vipRules.vipDemotionRule')
    },
    {
      title: t('vipRules.criteria5'),
      content: t('vipRules.vipLevelBonus')
    },
    {
      title: t('vipRules.criteria6'),
      content: t('vipRules.birthdayBonus')
    },
    {
      title: t('vipRules.criteria7'),
      content: t('vipRules.weeklyBonusRule')
    },
    {
      title: t('vipRules.criteria8'),
      content: t('vipRules.vipPromotionBonusRule'),
      footer: t('vipRules.footer8')
    },
    {
      title: t('vipRules.criteria9'),
      content: t('vipRules.vipPromotionVenueLimit'),
      footer: t('vipRules.footer9')
    },
  ]
  
  return (
    <div className={styles.vipRules}>
      <div className={styles.rules_title}>
        <div>VIP promotion</div>
        <div>{t('vipRules.vipTerms')}</div>
      </div>

      <div className={styles.rules_items}>
        {list.map((v,index)=>{
          return <div className={styles.item} key={index}>
            <div>{v.title}</div>
            <div>{v.content}</div>
            <div className={styles.footer}>{v.footer}</div>
          </div>
        })}
      </div>
    </div>
    )
  }
export default VipRules
